import React from 'react';
import { Box, Grid } from '@mui/material';
import SectionTitle from '../common/SectionTitle';
import ServiceCard from '../common/ServiceCard';
import Service1 from '../Assets/ServicesImages/Water Extraction & Structural Drying.png';  
import Service2 from '../Assets/ServicesImages/Emergency Roof Tarping & Leak Response.png';
import Service3 from '../Assets/ServicesImages/Mold Prevention & Remediation.png';
import Service4 from '../Assets/ServicesImages/Sewage Cleanup.png';  
import Service5 from '../Assets/ServicesImages/Content Cleaning & Pack Out.png';  
import Service6 from '../Assets/ServicesImages/Drywall & Flooring Repair.png';  
import Service7 from '../Assets/ServicesImages/Emergency Roof Tarping & Leak Response 1.png';  

import ServicesStack from './Services/ServicesStack';
import ServicesHeroSection from './Services/ServicesHero';
import ServicesCarousel from './ServicesCarousel';
import BookingProcess from './BookingProcess';

import { div } from 'framer-motion/client';


const services = [
  {
    title: 'Water Extraction & Structural Drying',
    priceFrom: '$29',
    image: Service1
  },
  {
    title: 'Dehumidification & Air Movers',
    priceFrom: '$49',
    image: Service2
  },
  {
    title: 'Mold Prevention & Remediation',
    priceFrom: '$39',
    image: Service3
  },
  {
    title: 'Sewage Cleanup (Black Water)',
    priceFrom: '$59',
    image: Service4
  },
  {
    title: 'Content Cleaning & Pack Out',
    priceFrom: '$59',
    image: Service5
  },
  {
    title: 'Drywall & Flooring Repair',
    priceFrom: '$59',
    image: Service6
  },
  {
    title: 'Emergency Tarps & Roof Leak Response',
    priceFrom: '$59',
    image: Service7
    
  }
];

const ServicesSection = () => {
  return (
    <div>
      {/* Hero Image */}
      <ServicesHeroSection/>

      <ServicesStack/>

      <ServicesCarousel/>

      <BookingProcess/>
   

    <Box id="services" sx={{ py: { xs: 8, md: 10 } }}>



      <Box sx={{ maxWidth: 1200, mx: 'auto', px: 2 }}>
        <SectionTitle
          overline="Services"
          title="Our Services"
          subtitle="Choose a service that matches your space and schedule. Every visit is handled by vetted professionals using high-quality products."
        />

        <Grid container spacing={4}>
          {services.map((service) => (
            <Grid key={service.title} item xs={12} sm={6} md={3}>
              <ServiceCard {...service} />
            </Grid>
          ))}
        </Grid>
      </Box>

    </Box>
    </div>
  );
};

export default ServicesSection;
